<template>
	<div class="hovering-input flex-center--end">
		<div class="input-container">
			{{ value }}
		</div>
		<div @click="$emit('edit')" class="edit-button ml-1">edit</div>
	</div>
</template>

<script>
export default {
	name: 'InputWithHoveringEditButton',
	props: {
		value: { type: String },
	},
};
</script>

<style lang="scss" scoped>
.hovering-input {
	font-size: 12px;
	font-weight: normal;
	color: var(--secondary-font-color);
	.input-container {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.edit-button {
		cursor: pointer;
		font-size: 11px;
		font-weight: 500;
		text-decoration: underline;
		color: var(--primary-font-color);
	}
	.edit-button {
		display: none;
	}
	&:hover {
		.edit-button {
			display: block;
		}
	}
}
</style>
